const initialState = {
  urlLinkSource: null,
  documentIdValue: "",
  showKeyboard: false,
  urlTotemId: null,
  downlaodStatus: false,
};

const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_URL_LINK_SOURCE":
      return {
        ...state,
        urlLinkSource: action.payload,
      };
    case "CLEAR_URL_LINK_SOURCE":
      return {
        ...state,
        urlLinkSource: null,
      };
    case "SET_DOCUMENT_ID_VALUE":
      return {
        ...state,
        documentIdValue: action.payload,
      };
    case "SET_SHOW_KEYBOARD":
      return {
        ...state,
        showKeyboard: action.payload,
      };
    case "SET_URL_TOTEM_ID":
      return {
        ...state,
        urlTotemId: action.payload,
      };
    case "SET_DOWNLOAD_EVENT":
      return {
        ...state,
        downlaodStatus: action.payload,
      };
    default:
      return state;
  }
};

export default globalReducer;
